import React from 'react';
import FormBasicInformation from './FormBasicInformation';
import { Box, Chip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const FormPreview = ({
  form,
  errors,
  onChange,
  optionsAssessmentAreas,
  isLoadingAssessmentAreas,
  errorAssessmentAreas,
  currentCurriculum
}) => {
  const subjects = useSelector((state) => state?.subject?.list || []);
  const subjectsData = subjects.filter((subject) => form.subjectId?.includes(subject._id));

  return (
    <>
      <FormBasicInformation
        form={form}
        errors={errors}
        onChange={onChange}
        type={'preview'}
        optionsAssessmentAreas={optionsAssessmentAreas}
        isLoadingAssessmentAreas={isLoadingAssessmentAreas}
        errorAssessmentAreas={errorAssessmentAreas}
        currentCurriculum={currentCurriculum}
      />
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex justify-between items-center gap-1 h-8'>
        <Typography>Subjects ({subjectsData?.length})</Typography>
      </Box>
      <Box className='px-2 py-2'>
        {subjectsData?.length > 0 ? (
          subjectsData?.map((subject) => <Chip key={subject._id} label={subject.name} className='m-1' />)
        ) : (
          <Typography
            color='inherit'
            component={'p'}
            className='text-muted-foreground opacity-50 py-2 text-center'
          >
            You don't have any subjects yet
          </Typography>
        )}
      </Box>
    </>
  );
};

export default FormPreview;
